import { render, staticRenderFns } from "./BgGrid1.vue?vue&type=template&id=bb439e44&scoped=true&"
import script from "./BgGrid1.vue?vue&type=script&lang=js&"
export * from "./BgGrid1.vue?vue&type=script&lang=js&"
import style0 from "./BgGrid1.vue?vue&type=style&index=0&id=bb439e44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb439e44",
  null
  
)

export default component.exports